import "@fontsource-variable/manrope/wght.css";
import "@fontsource/ibm-plex-mono/latin-ext-400.css";
import "@fontsource/ibm-plex-mono/latin-ext-500.css";
import "@fontsource/ibm-plex-mono/latin-ext-600.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./design/tokens.css";
import "./styles.css";
import { BrowserRoot } from "./features/auth/BrowserRoot";
import { readBrowserBootstrap } from "./features/sessions/api";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Elementul #root lipsește.");
}

const mount = async (): Promise<void> => {
  const bootstrap = await readBrowserBootstrap(window.location);

  createRoot(root).render(
    <StrictMode>
      <BrowserRoot
        initialBootstrap={bootstrap}
        retryBootstrap={() => readBrowserBootstrap(window.location)}
      />
    </StrictMode>,
  );
};

void mount();
